/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsStation } from "../../entities/models/Station";
import { z } from "zod/v4";

export const modelsStationSchema = z.object({
    "branch_id": z.optional(z.int()),
"created_at": z.optional(z.string()),
"display_order": z.optional(z.int()),
"id": z.optional(z.int()),
"is_active": z.optional(z.boolean()),
"name": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsStation>